var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.83562 0 0 7.83562 0 17.5C0 27.1644 7.83562 35 17.5 35C27.1644 35 35 27.1644 35 17.5C35 7.83562 27.1644 0 17.5 0ZM15.3125 17.5H19.6875C22.1003 17.5 24.0625 19.4622 24.0625 21.875V24.0625C24.0625 26.4753 22.1003 28.4375 19.6875 28.4375V30.625H17.5V28.4375H15.3125C12.8997 28.4375 10.9375 26.4753 10.9375 24.0625H13.125C13.125 25.2678 14.105 26.25 15.3125 26.25H17.5H19.6875C20.895 26.25 21.875 25.2678 21.875 24.0625V21.875C21.875 20.6697 20.895 19.6875 19.6875 19.6875H15.3125C12.8997 19.6875 10.9375 17.7253 10.9375 15.3125V13.125C10.9375 10.7122 12.8997 8.75 15.3125 8.75H17.5V6.5625H19.6875V8.75C22.1003 8.75 24.0625 10.7122 24.0625 13.125H21.875C21.875 11.9197 20.895 10.9375 19.6875 10.9375H15.3125C14.105 10.9375 13.125 11.9197 13.125 13.125V15.3125C13.125 16.5178 14.105 17.5 15.3125 17.5Z",
    fill: "#031B76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.d474671a41dfc5a0121694b84b230808.svg";
export { ForwardRef as ReactComponent };